import { render, staticRenderFns } from "./RouteComments.vue?vue&type=template&id=f958875a&scoped=true"
import script from "./RouteComments.vue?vue&type=script&lang=js"
export * from "./RouteComments.vue?vue&type=script&lang=js"
import style0 from "./RouteComments.vue?vue&type=style&index=0&id=f958875a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f958875a",
  null
  
)

export default component.exports